// utils
import axios from '../../../utils/axios';

const getSubscription = async (type, typeId) => {
  try {
    const response = await axios({
      method: 'get',
      url: `/lexus/gmb-wallet/api/subscriptions/pricings`,
      params: { type, typeId },
    });
    const res = await response.data;
    return res;
  } catch (error) {
    throw new Error(JSON.stringify(error));
  }
};

export { getSubscription };
